

export default function() {
    function pills(page, event) {
        if (page) {
            let pillsTags = [],
                pillsEventType = [];

            // Only for events
            if (page.sectionHandle === 'educationAndEvents' && page.type && page.type.length) {
                const entryType = event.typeHandle === 'onDemand' ? 'education' : 'events';
                pillsEventType = [{
                    title: page.type[0].title,
                    uri: `education-events/${entryType}?type=${page.type[0].slug}`
                }];
            }

            // Tags
            if (page.tags) {
                pillsTags = page.tags.map((tag) => {
                    return {
                        title: tag.title,
                        uri: `tags/${tag.slug}`
                    };
                });
            }

            // Offices, sections and topics
            const pillsOffices = page.offices ? page.offices.filter(office => office.entryType === 'offices_office_Entry') : [],
                pillsSections = page.sectionEntries ? page.sectionEntries.filter(section => section.entryType === 'eauSections_eauSection_Entry') : [],
                pillsTopics = page.topics ? page.topics : [];

            return pillsEventType.concat(pillsTopics, pillsTags, pillsSections, pillsOffices);
        }
        return [];
    }
    return {
        pills
    };
}
